var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 818.84 818.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 166.76,
    y: 325.15,
    width: 104.34,
    height: 337.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.42,281.01c34.08,0,61.7-27.87,61.7-62.21s-27.61-62.19-61.7-62.19-61.7,27.85-61.7,62.19,27.61,62.21,61.7,62.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.88,485.28c0-47.39,21.81-75.62,63.58-75.62,38.36,0,56.8,27.1,56.8,75.62v176.94h103.85v-213.42c0-90.29-51.18-133.94-122.65-133.94s-101.58,55.69-101.58,55.69v-45.4h-100.09v337.08h100.09v-176.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M409.42,815.84C185.32,815.84,3,633.52,3,409.42S185.32,3,409.42,3s406.42,182.32,406.42,406.42-182.32,406.42-406.42,406.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.8c7ff678.svg";
export { ForwardRef as ReactComponent };